import React, { useState } from 'react';
import { Card, Button, Dimmer, Grid, Tabs, Tab, Form, Table, Avatar, Tag } from "tabler-react";
import { useFetch } from '../../lib/useFetch';
import { formatDate } from '../../lib/helpers';
import PriceDetails from './price-details';
import Offers from '../offers';
import PhotoModal from '../../components/modal/photoModal';

const productsHeaders = ["Photo", "Name", "Weight", "Price", "Quantity", "Category", "Subcategory"]

const ShipmentViewModal = ({ recordId, closeMainModal, extraData: tripID }) => {
  const { data: shipment, loading: shipmentLoading } = useFetch(`shipments/${recordId}`);
  const { data: trip } = useFetch(`trips/${tripID}`, tripID);
  const [modalPhoto, setModalPhoto] = useState(null)

  return (
    <Card>
      {modalPhoto &&
        <PhotoModal photo={shipment.owner.photo} close={() => setModalPhoto(null)} />
      }

      <Dimmer active={shipmentLoading} loader={shipmentLoading}>
        <Card.Header>
          <Card.Title>Shipment</Card.Title>
          <Card.Options>
            <Button
              size="sm"
              icon="x"
              onClick={() => closeMainModal()}
            />
          </Card.Options>
        </Card.Header>
        {!shipmentLoading && shipment &&
          <Card.Body>
            <Tabs initialTab="Shipment Details">
              <Tab title="Shipment Details">
                <Form.FieldSet>
                  <Grid>
                    <Grid.Row>
                      <Grid.Col width={6}>
                        <Form.Label>Pick Up</Form.Label>
                        <div className="normalText">{shipment.fromCity.countryName}, {shipment.fromCity.name}</div>

                        <Form.Label>Destination</Form.Label>
                        <div className="normalText">{shipment.toCity.countryName}, {shipment.toCity.name}</div>

                        <Form.Label>Deliver Before</Form.Label>
                        <div className="normalText">{formatDate(new Date(shipment.shipmentArrivalDate))}</div>

                        <Form.Label>Status</Form.Label>
                        <div className="normalText">{shipment.state}</div>
                      </Grid.Col>
                      <Grid.Col width={6}>
                        <Form.Label>Shipment Type</Form.Label>
                        <div className="normalText">{shipment.shipmentType}</div>

                        <Form.Label>Products Quantity</Form.Label>
                        <div className="normalText">{shipment.quantity}</div>

                        <Form.Label>Total Weight</Form.Label>
                        <div className="normalText">{shipment.totalWeight}</div>

                        <Form.Label>Milestone</Form.Label>
                        <div className="normalText">{shipment.milestone}</div>
                      </Grid.Col>
                    </Grid.Row>
                  </Grid>
                </Form.FieldSet>
              </Tab>

              {shipment.milestone === "In Progress" && trip &&
                <Tab title="Trip Details">
                  <Form.FieldSet>
                    <Grid>
                      <Grid.Row>
                        <Grid.Col>
                          <Form.Label>Pick Up</Form.Label>
                          <div className="normalText">{trip.fromCity.countryName}, {trip.fromCity.name}</div>

                          <Form.Label>Destination</Form.Label>
                          <div className="normalText">{trip.toCity.countryName}, {trip.toCity.name}</div>

                          <Form.Label>Trip Date</Form.Label>
                          <div className="normalText">{formatDate(new Date(trip.tripDate))}</div>

                          <Form.Label>Status</Form.Label>
                          <div className="normalText">{trip.state}</div>
                        </Grid.Col>

                        <Grid.Col>
                          <Form.Label>Trip Capacity</Form.Label>
                          <div className="normalText">{trip.tripCapacity}</div>

                          <Form.Label>Trip Type</Form.Label>
                          <div className="normalText">{trip.tripType}</div>

                          <Form.Label>Vehicle Type</Form.Label>
                          <div className="normalText">{trip.vehicleType}</div>

                          <Form.Label>Milestone</Form.Label>
                          <div className="normalText">{trip.milestone}</div>
                        </Grid.Col>
                      </Grid.Row>
                    </Grid>
                  </Form.FieldSet>
                </Tab>
              }

              <Tab title="Products">
                <Table hasOutline striped>
                  <Table.Header>
                    {productsHeaders.map((head, i) => (
                      <Table.ColHeader key={`tableHeader-${i}`}>{head}</Table.ColHeader>
                    ))}
                    <Table.ColHeader>Actions</Table.ColHeader>
                  </Table.Header>
                  <Table.Body>
                    {shipment.products.map((r, i) => (
                      <Table.Row key={i}>
                        <Table.Col>
                          <Avatar size="md" imageURL={r.picture} />
                        </Table.Col>

                        <Table.Col>
                          {r.name}
                        </Table.Col>

                        <Table.Col>
                          {r.weight}
                        </Table.Col>

                        <Table.Col>
                          {r.price}
                        </Table.Col>

                        <Table.Col>
                          {r.quantity}
                        </Table.Col>

                        <Table.Col>
                          {r.categoryName}
                        </Table.Col>

                        <Table.Col>
                          {r.subCategoryName}
                        </Table.Col>

                        <Table.Col>
                          <a href={r.productUrl} target="_blank" rel="noreferrer">Visit</a>
                        </Table.Col>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
              </Tab>

              <Tab title="Price Estimates">
                <PriceDetails shipment={shipment} />
              </Tab>

              <Tab title="Offers">
                <Offers params={`shipmentId=${shipment._id}`} />
              </Tab>

              <Tab title="Shopper Info">
                <Form.FieldSet>
                  <Grid>
                    <Grid.Row>
                      <Grid.Col>
                        <Form.Label>User Photo</Form.Label>
                        <Avatar size="md" imageURL={shipment.owner.photo} className="mb-2 clickable"
                          onClick={() => setModalPhoto(shipment.owner.photo)} />

                        <Form.Label>Name</Form.Label>
                        <div className="normalText">{`${shipment.owner.firstName} ${shipment.owner.lastName}`}</div>

                        <Form.Label>Username</Form.Label>
                        <div className="normalText">{shipment.owner.username}</div>

                        <Form.Label>Phone Number</Form.Label>
                        <div className="normalText">{shipment.owner.phoneNumber}</div>
                      </Grid.Col>

                      <Grid.Col >
                        <Form.Label>Email</Form.Label>
                        <div className="normalText">{shipment.owner.email}</div>
                      </Grid.Col>

                      <Grid.Col>
                        <Form.Label>Balance</Form.Label>
                        <div className="normalText">{shipment.owner.balance}</div>

                        <Form.Label>Is Phone Verified</Form.Label>
                        <div className="normalText">{shipment.owner.isPhoneVerified ? 'Yes' : 'No'}</div>

                        <Form.Label>Is Passport Verified</Form.Label>
                        <div className="normalText">{shipment.owner.isPassportVerified ? 'Yes' : 'No'}</div>

                        <Form.Label>Is Payment Verified</Form.Label>
                        <div className="normalText">{shipment.owner.isPaymentVerified ? 'Yes' : 'No'}</div>
                      </Grid.Col>
                    </Grid.Row>
                  </Grid>

                  <Form.Label>Roles</Form.Label>
                  <Tag.List>
                    {shipment.owner.roles.map(item =>
                      <Tag>{item}</Tag>
                    )}
                  </Tag.List>
                </Form.FieldSet>
              </Tab>

              {shipment.milestone === "In Progress" && trip &&
                <Tab title="Traveller Info">
                  <Form.FieldSet>
                    <Grid>
                      <Grid.Row>
                        <Grid.Col>
                          <Form.Label>User Photo</Form.Label>
                          <Avatar size="md" imageURL={trip.owner.photo} className="mb-2 clickable"
                            onClick={() => setModalPhoto(trip.owner.photo)} />

                          <Form.Label>Name</Form.Label>
                          <div className="normalText">{`${trip.owner.firstName} ${trip.owner.lastName}`}</div>

                          <Form.Label>Username</Form.Label>
                          <div className="normalText">{trip.owner.username}</div>

                          <Form.Label>Phone Number</Form.Label>
                          <div className="normalText">{trip.owner.phoneNumber}</div>
                        </Grid.Col>

                        <Grid.Col >
                          <Form.Label>Email</Form.Label>
                          <div className="normalText">{trip.owner.email}</div>
                        </Grid.Col>

                        <Grid.Col>
                          <Form.Label>Balance</Form.Label>
                          <div className="normalText">{trip.owner.balance}</div>

                          <Form.Label>Is Phone Verified</Form.Label>
                          <div className="normalText">{trip.owner.isPhoneVerified ? 'Yes' : 'No'}</div>

                          <Form.Label>Is Passport Verified</Form.Label>
                          <div className="normalText">{trip.owner.isPassportVerified ? 'Yes' : 'No'}</div>

                          <Form.Label>Is Payment Verified</Form.Label>
                          <div className="normalText">{trip.owner.isPaymentVerified ? 'Yes' : 'No'}</div>
                        </Grid.Col>
                      </Grid.Row>
                    </Grid>

                    <Form.Label>Roles</Form.Label>
                    <Tag.List>
                      {trip.owner.roles.map(item =>
                        <Tag>{item}</Tag>
                      )}
                    </Tag.List>
                  </Form.FieldSet>
                </Tab>
              }
            </Tabs>
          </Card.Body>
        }
      </Dimmer>
    </Card>
  )
}

export default ShipmentViewModal;
